import { Marketplace } from 'types/Marketplace';

export interface MarketplaceState {
    data: Marketplace;
    status: MarketplaceStatus;
    loading: boolean;
}

export enum MarketplaceStatus {
    Initial,

    Fetching,
    FetchSuccess,

    Error
}
